import { Component, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { Router } from '@angular/router';
import { UserInfo } from './_models/UserInfo.model';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './_services/config.service';
import { Location } from '@angular/common';
import { TipiButtonForm } from './workflow/_models/TipiButtonForm';
import { TipiCampoForm } from './workflow/_models/TipiCampoForm';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { Portal } from './_models/portal/Portal.model';
import { UserPw } from './_models/portal/User-pw.model';
import { environment } from '../environments/environment';

@Component({
	standalone: false,
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
	model: UserPw = new UserPw();
	user: UserInfo = new UserInfo();
	portali: Portal[] = [];

	/** Badge ambiente: visibile solo fuori produzione (dev, collaudo/test, local...). */
	readonly showEnvBadge = !environment.production;
	/** True per i profili di collaudo (*-test), false per dev/local. */
	readonly isEnvTest = /test/i.test(environment.profile);
	/** Etichetta mostrata nel triangolo: TEST per il collaudo, DEV altrimenti. */
	readonly envLabel = this.isEnvTest ? 'TEST' : 'DEV';

	//private routerSub: any;
	SupportedLanguages: string[] = ['en', 'it'];

	constructor(
		private messageService: MessageService,
		private spinner: NgxSpinnerService,
		private location: Location,
		private primeng: PrimeNG,
		private configService: ConfigService,
		private router: Router,
		private translate: TranslateService,
	) {
		this.spinner.show('app');

		TipiCampoForm.initialize();
		TipiButtonForm.initialize();
	}

	ngOnInit() {
		this.setLanguage();
		this.primeng.ripple.set(true);

		const apiKey = this.configService.apiGoogleMapsKey;
		if (apiKey) {
			const GoogleMapsScript = document.createElement('script');
			GoogleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
			GoogleMapsScript.async = true;
			GoogleMapsScript.defer = true;
			document.head.appendChild(GoogleMapsScript);
		}

		const baseurl = window.location.hostname;
		const params = new URLSearchParams(window.location.search);
		const tokenQueryParam = params.get('?UIID');
		let guid = params.get('guid');
		let type = params.get('type');
		console.log('app.component.ts - window.location.search:', window.location.search);
		console.log('app.component.ts - guid:', guid, 'type:', type);
		if (guid && type) {
			localStorage.setItem('guid', guid);
			localStorage.setItem('type', type);
			console.log('app.component.ts - stored guid and type in localStorage');
		}

		if (tokenQueryParam != null) {
			// Handle login
		} else {
			const currentUser = this.configService.getLocalStorageObjectJson('currentUser');

			if (currentUser != null) {
				if (localStorage.getItem('portale')) {
					const portale = this.configService.getLocalStorageObjectJson('portale');
					document.body.className = portale.pt_theme;
				}
				if (type === 'doctor' && guid) {
					localStorage.removeItem('guid');
					localStorage.removeItem('type');
					this.router.navigate(['/workflow/execute', guid]);
				}
			} else {
				console.log('appComponent ngOnInit login_due_fattori');

				//this.router.navigate(['/login_due_fattori'], { replaceUrl: true });
			}
		}
	}

	setLanguage() {
		this.translate.addLangs(this.SupportedLanguages);
		if (this.configService.getLocalStorageLanguage() != 'KO') {
			this.configService.language = this.configService.getLocalStorageLanguage();
		} else if (this.configService.getUser()) {
			this.configService.language = this.configService.getLanguage();
		} else {
			this.configService.language = 'it';
		}
		this.translate.use(this.configService.language);
		this.setLocale(this.primeng, this.configService.language);
		setTimeout(() => {
			this.spinner.hide('app');
		}, 1000);
	}

	setLocale(config: PrimeNG, locale: string): void {
		const normalizedLocale = locale.trim().toLowerCase();

		switch (normalizedLocale) {
			case 'en': {
				const dow: string[] = config.getTranslation('dayNames');
				if (dow[0] !== 'Sunday') {
					console.warn('Default locale is not English. Setting English translations.');
				}
				config.setTranslation({
					startsWith: 'Starts with',
					contains: 'Contains',
					notContains: 'Does not contain',
					endsWith: 'Ends with',
					equals: 'Equals',
					notEquals: 'Does not equal',
					noFilter: 'No Filter',
					lt: 'Less than',
					lte: 'Less than or equal to',
					gt: 'Greater than',
					gte: 'Greater than or equal to',
					is: 'Is',
					isNot: 'Is not',
					before: 'Before',
					after: 'After',
					apply: 'Apply',
					matchAll: 'Match All',
					matchAny: 'Match Any',
					addRule: 'Add Rule',
					removeRule: 'Remove Rule',
					accept: 'Yes',
					reject: 'No',
					choose: 'Choose',
					upload: 'Upload',
					cancel: 'Cancel',
					dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
					dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
					monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					today: 'Today',
					clear: 'Clear',
					weekHeader: 'Wk',
				});
				break;
			}
			case 'it': {
				config.setTranslation({
					startsWith: 'Inizia con',
					contains: 'Contiene',
					notContains: 'Non contiene',
					endsWith: 'Finisce con',
					equals: 'Uguale',
					notEquals: 'Non uguale',
					noFilter: 'Nessun filtro',
					lt: 'Minore di',
					lte: 'Minore o uguale a',
					gt: 'Maggiore di',
					gte: 'Maggiore o uguale a',
					is: 'È',
					isNot: 'Non è',
					before: 'Prima',
					after: 'Dopo',
					apply: 'Applica',
					matchAll: 'Corrispondi a tutti',
					matchAny: 'Corrispondi a qualsiasi',
					addRule: 'Aggiungi regola',
					removeRule: 'Rimuovi regola',
					accept: 'Sì',
					reject: 'No',
					choose: 'Scegli',
					upload: 'Carica',
					cancel: 'Annulla',
					dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
					dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
					dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
					monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
					monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
					today: 'Oggi',
					clear: 'Cancella',
					weekHeader: 'Sett',
				});
				break;
			}
			case 'de': {
				console.warn('German locale not implemented yet.');
				break;
			}
			default: {
				console.error(`Locale '${locale}' not available. Falling back to English.`);
				config.setTranslation({
					startsWith: 'Starts with',
					contains: 'Contains',
					notContains: 'Does not contain',
					endsWith: 'Ends with',
					equals: 'Equals',
					notEquals: 'Does not equal',
					noFilter: 'No Filter',
					lt: 'Less than',
					lte: 'Less than or equal to',
					gt: 'Greater than',
					gte: 'Greater than or equal to',
					is: 'Is',
					isNot: 'Is not',
					before: 'Before',
					after: 'After',
					apply: 'Apply',
					matchAll: 'Match All',
					matchAny: 'Match Any',
					addRule: 'Add Rule',
					removeRule: 'Remove Rule',
					accept: 'Yes',
					reject: 'No',
					choose: 'Choose',
					upload: 'Upload',
					cancel: 'Cancel',
					dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
					dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
					monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					today: 'Today',
					clear: 'Clear',
					weekHeader: 'Wk',
				});
				break;
			}
		}
	}

	ngOnDestroy() {
		/*if (this.routerSub) {
			this.routerSub.unsubscribe();
		}*/
	}

	goBack(): void {
		this.location.back();
	}
}
